import type { PlannedMove } from '../../../types/preplanning';

type PreferenceMove = Pick<PlannedMove, 'origcode' | 'destcode' | 'origin_name' | 'dest_name'>;
type PreferenceDriver = { preferred_location_ids?: number[]; not_preferred_location_ids?: number[] };

export type LocationPreferenceTone = 'preferred' | 'not_preferred';

/** How the driver feels about where a card sends them, from Drivers → Preferences/Bans.
 * Checks both ends of every move on the card. A disliked location wins over a liked one:
 * the driver is still being sent somewhere they dislike (John, 2026-10-28).
 * Null when nothing matches, or on a plan saved before the board carried the lists. */
export function locationPreferenceTone(moves: PreferenceMove[], driver: PreferenceDriver | undefined) {
  if (!driver) return null;
  const match = (ids: number[] | undefined) => {
    if (!ids?.length) return null;
    const set = new Set(ids);
    for (const m of moves) {
      if (m.origcode != null && set.has(m.origcode)) return m.origin_name;
      if (m.destcode != null && set.has(m.destcode)) return m.dest_name;
    }
    return null;
  };
  const disliked = match(driver.not_preferred_location_ids);
  if (disliked) return { tone: 'not_preferred' as const, location: disliked, title: `Driver does not prefer ${disliked}` };
  const liked = match(driver.preferred_location_ids);
  if (liked) return { tone: 'preferred' as const, location: liked, title: `Driver prefers ${liked}` };
  return null;
}
